var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgRegistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.12 6.6A1.02 1.02 0 0 0 2.1 7.62v13.627c0 .563.457 1.02 1.02 1.02h13.628a1.02 1.02 0 0 0 1.02-1.02V9l-.8 1v11.247a.22.22 0 0 1-.22.22H3.12a.22.22 0 0 1-.22-.22V7.62a.22.22 0 0 1 .22-.22h11.118L15 6.6H3.12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.216 4.519 2.457 2.137L21.636 4.4l-2.457-2.137-1.963 2.256Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.975 6.919a.4.4 0 0 1-.564.04L16.954 4.82a.4.4 0 0 1-.04-.565L18.878 2a.4.4 0 0 1 .564-.039L21.898 4.1a.4.4 0 0 1 .04.564L19.975 6.92Zm-.34-.827 1.437-1.652-1.854-1.613-1.437 1.653 1.853 1.612Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.83 16.28a.4.4 0 0 1-.564.04L8.81 14.182a.4.4 0 0 1-.039-.564l8.143-9.361a.4.4 0 0 1 .565-.04l2.457 2.138a.4.4 0 0 1 .039.564l-8.143 9.361Zm-.34-.827 7.618-8.757-1.854-1.612-7.618 8.757 1.854 1.612Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#152F4D",
    d: "m8.448 17.078 3.082-1.06-2.459-2.14-.623 3.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.186 17.38a.4.4 0 0 1-.13-.378l.622-3.2a.4.4 0 0 1 .656-.226l2.459 2.14a.4.4 0 0 1-.132.68l-3.083 1.06a.4.4 0 0 1-.392-.076Zm.787-.905 1.772-.61-1.414-1.23-.358 1.84Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgRegistry);
export default __webpack_public_path__ + "static/media/org-registry.f3c9dc5fbc7d357ed58c37b7481f03de.svg";
export { ForwardRef as ReactComponent };